/**
 * 日期：2020-09-22 tcw
 * 接口说明：北京发票、贵阳发票接口文件
*/
import request from '@/utils/request'

// invoiceApplyBj 申请开票
// invoiceRecordBj 直播会议
// invoiceDiscardBj 会员服务
// 北京发票-开票申请列表
export function getInvoiceListBj(data, type) {
  // 交易结算、直播会议、会员服务
  const url = ['占位', 'invoice/make_invoice_application_apply', 'invoice/kpsq_zhibo', 'invoice/kpsq_hy']
  return request({
    url: url[type],
    method: 'post',
    data: data
  })
}
// 开票申请-审核-详情信息
export function getInvoiceDetail(data, type) {
  // 交易结算、直播会议、会员服务
  const url = ['占位', 'invoice/make_invoice_application_apply_detail', 'invoice/kpsq_zhibo_detail', 'invoice/kpsq_hy_detail']
  return request({
    url: url[type],
    method: 'post',
    data: data
  })
}
// 开票申请-审核-账单明细
export function getInvoiceDetailTable(data, type) {
  // 交易结算、直播会议、会员服务
  const url = ['占位', 'invoice/make_invoice_application_bill_detail', 'invoice/kpsq_zhibo_bill_detail', 'invoice/kpsq_hy_bill_detail']
  const paramsType = ['', 'invoice_business_apply_id', 'invoice_live_apply_id', 'invoice_hy_apply_id']
  const name = paramsType[type]
  return request({
    url: url[type],
    method: 'post',
    data: {
      [name]: data
    }
  })
}
// 开票申请-审核-审核-提交（一审）
export function getInvoiceDetailExamine(data, type) {
  // 交易结算、直播会议、会员服务
  const url = ['占位', 'invoice/make_invoice_application_first_check', 'invoice/kpsq_zhibo_first_check', 'invoice/kpsq_hy_first_check']
  return request({
    url: url[type],
    method: 'post',
    data: data,
    formData: true
  })
}
// 开票申请-审核-填写物流信息-提交（二审）
export function getInvoiceDetailLogistics(data, type) {
  // 交易结算、直播会议、会员服务
  const url = ['占位', 'invoice/make_invoice_application_second_check', 'invoice/kpsq_zhibo_second_check', 'invoice/kpsq_hy_second_check']
  return request({
    url: url[type],
    method: 'post',
    data: data
  })
}
// 北京发票-开票记录列表
export function getInvoiceRecordListBj(data, type) {
  // 交易结算、直播会议、会员服务
  const url = ['占位', 'invoice/kpjl_apply', 'invoice/kpjl_zhibo', 'invoice/kpjl_hy']
  return request({
    url: url[type],
    method: 'post',
    data: data
  })
}
// 北京发票-作废记录
export function getZfjl(data, type) {
  // 交易结算、直播会议、会员服务
  const url = ['占位', 'invoice/zfjl_apply', 'invoice/zfjl_zhibo', 'invoice/zfjl_hy']
  return request({
    url: url[type],
    method: 'post',
    data: data
  })
}
// 贵阳-开票申请
export function getInvoiceListGy(data) {
  return request({
    url: 'invoice/kpsq_dy',
    method: 'post',
    data: data
  })
}
// 贵阳-申请记录
export function getInvoiceRecordListGy(data) {
  return request({
    url: 'invoice/kpjl_dy',
    method: 'post',
    data: data
  })
}
// 贵阳-作废记录
export function getZfjlGy(data) {
  return request({
    url: 'invoice/zfjl_dy',
    method: 'post',
    data: data
  })
}
// 贵阳-详情页面
export function getivoiceDetailGy(data) {
  return request({
    url: 'invoice/kpsq_dy_detail',
    method: 'post',
    data: data
  })
}
// 贵阳-账单详情
export function getInvoiceDetailTableGy(data) {
  return request({
    url: 'invoice/kpsq_dy_bill_detail',
    method: 'post',
    data: {
      invoice_report_apply_id: data
    }
  })
}
// 贵阳-开票申请-审核-审核-提交（一审）
export function getInvoiceDetailExamineGy(data) {
  return request({
    url: 'invoice/kpsq_dy_first_check',
    method: 'post',
    data: data,
    formData: true
  })
}
// 贵阳-开票申请-审核-填写物流信息-提交（二审）
export function getInvoiceDetailLogisticsGy(data) {
  return request({
    url: 'invoice/kpsq_dy_second_check',
    method: 'post',
    data: data
  })
}

